<script setup lang="ts">
import type { Component } from "vue";
import SpinnerComponent from "@/components/layouts/SpinnerComponent.vue";

interface Props {
  component: Component;
}

defineProps<Props>();
</script>

<template>
  <suspense timeout="80">
    <template #default>
      <component :is="component"></component>
    </template>
    <template #fallback>
      <div
        class="flex justify-center fixed w-screen h-[calc(100dvh-88px)] items-center top-0 left-0"
      >
        <SpinnerComponent background="text-neutral100" />
      </div> </template
  ></suspense>
</template>
